import { Exception } from '../../../../core/logic/exception';

export class BillNotFoundException extends Exception<never> {
  constructor() {
    super('Facture non trouvée');
  }
}
